import "./Information.css";
import config from "../config";

export default function Information() {


  return (
    <div className="information">
      <hr></hr>
      <br></br>

      <h1>What is this?</h1>
      <p>
        Pixel Place is a social experiment inspired by <a href="https://reddit.com/r/place">r/place</a> and <a href="http://www.milliondollarhomepage.com/">The Million Dollar Homepage</a> that operates on the Tezos blockchain.
        It is a 64x64 pixel canvas that anyone can draw to.
      </p>
      <p>
        Click or tap on a pixel and select a colour, then press the "Set Pixel" button to prompt the transaction.
      </p>

      <h1>How does it work?</h1>
      <p>
        The canvas above displays the storage of a smart contract deployed on the Tezos blockchain.
        The image itself is not stored on-chain, this website just produces it using <a href="https://p5js.org/">p5.js</a>.
        The contract only stores the colour index from 0-15 for each x and y position.
      </p>

      <h1>Why the fee?</h1>
      <p>
        Pixel Place costs 0.01ꜩ/pixel as I don't want bots to take over the canvas with the limited amount of space.
        This <i>hopefully</i> ensures that only those who wish to edit fairly will be placing pixels :)
      </p>

      <br></br>
      <hr></hr>

      <br></br>
      <a id="contract-link" href={"https://better-call.dev/mainnet/" + config.contractAddress}>{config.contractAddress}</a>
      <br></br>
    </div>
  );
}
